<template>
  <div>
    <el-table :data="data" class="hidden lg:block table-product" :empty-text="$t('common.placeholder.noDataText')">
      <el-table-column :label="$t('ec-line003.itemTable.product')">
        <template slot-scope="scope">
          <div class="flex items-center justify-start">
            <img :src="image(scope.row)" width="100" height="100" />
            <div class="text-base font-bold text-black ml-4">{{ scope.row.product_name }}</div>
          </div>
        </template>
      </el-table-column>
      <!-- 会員ランク：単価 column title -->
      <el-table-column prop="sku" width="92">
        <template #header>
          <i18n path="common.cart.formatLabel">
            <template #label>
              <span>{{ $t('common.cart.unitPrice') }}</span>
            </template>
            <template #tax>
              <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
            </template>
          </i18n>
        </template>
        <template slot-scope="scope">
          <i18n path="common.cart.formatPrice">
            <template #price>
              <span>{{ scope.row.price.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
        </template>
      </el-table-column>
      <!-- 個数 -->
      <el-table-column :label="$t('ec-line003.itemTable.quantity')" width="92">
        <template slot-scope="scope">
          <div class="flex items-center justify-start">
            <div class="text-base text-black ml-4">{{ scope.row.quantity }}</div>
          </div>
        </template>
      </el-table-column>
      <!-- 会員ランク：小計・割引額 column title -->
      <el-table-column width="200">
        <template #header>
          <div class="item-table-subtotal">
            <i18n path="common.cart.formatLabel" class="flex items-center">
              <template #label>
                <span>{{ $t('common.cart.subTotal') }}</span>
              </template>
              <template #tax>
                <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
              </template>
            </i18n>
            <span>{{ $t('ec-line003.itemTable.discount') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <i18n path="common.cart.formatPrice">
            <template #price>
              <span>{{ scope.row.subtotal.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
          <div v-if="scope.row.discount_amount_total !== 0" class="text-xs">
            <span> {{ $t('common.label.priceDiscount') }}</span>
            <i18n path="common.cart.formatPrice" class="text-red ml-1">
              <template #price>
                <span>{{ scope.row.discount_amount_total.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, required: true, default: () => {} },
  },
  methods: {
    image(data) {
      return data.product_image ? data.product_image : require('@/assets/images/gray-image.svg')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-list-item.scss';
</style>
